export default __webpack_public_path__ + "static/media/P348_B_BD.c603aa75.pdf";